const Config = {
    "MAX_TAB" : 20,
    "PRE_START_PAGE":[
        "https://campadmin.english1.cn/ef_camp/datacenter/basic_data",
    ], //预加载页数组
    //子系统注销接口
    "SIGNOUT_3RD_URL":[
        "https://campadmin.english1.cn/admin/init/logout",
    ],
    "LOADING_INTERVAL":3000 //ms
}
export default Config;
